<ng-container *transloco="let convert;">
  @if (banner.text) {
    <app-banner data-test-id="service-carfax-banner" (close)="banner.text = ''" [bannerConfig]="banner"></app-banner>
  }
  <div class="row" data-test-id="service-carfax-container">
    <div class="col-md-6 margin-top-10">
      <h2 data-test-id="service-carfax-header" tabindex="-1" class="focus-outline-none">{{convert('profileManagement.serviceCarfax.header')}}</h2>
      <p data-test-id="service-carfax-title">{{convert('profileManagement.serviceCarfax.title')}}</p>

      <div class="button-container">
        <button data-test-id="service-carfax-login-logout-btn" class="btn btn-primary" data-track-elem="button" data-track-trigger="carfaxStateChange"
          [attr.data-track-name]="isUserLoggedIn ? 'CARFAX Log Out' : 'CARFAX Log In'"
          [attr.aria-label]="isUserLoggedIn ? convert('profileManagement.serviceCarfax.ariaLabelLogOut') : convert('profileManagement.serviceCarfax.ariaLabelLogIn')" (click)="openIntersiteDisclosure()">
          {{isUserLoggedIn ? convert('profileManagement.serviceCarfax.logOffBtn') : convert('profileManagement.serviceCarfax.logInBtn')}}
        </button>

      </div>

      <!-- The inventoryItemUuid field is needed for analytics.  -->
      <!-- Since there is no uuid at login, carfax is used in its place -->
      <app-common-interstitial-modal
        data-test-id="service-carfax-interstitial-modal"
        [modalId]="carfaxConstant"
        [reportProvider]="carfaxConstant"
        [inventoryItemUuid]="carfaxConstant"
        [tenantFullName]="tenantFullName"
        [commonInterstitialModalTranslations]="commonInterstitialModalTranslations"
        (continue)="changeCarfaxStatus($event)">
      </app-common-interstitial-modal>

    </div>
    <div class="col-md-6 carfax-logo-wrapper">
      <img data-test-id="service-carfax-logo" src="../../../ui/assets/icons/carfax-logo.svg" alt="carfax" class="carfax-icon" />
    </div>
  </div>
</ng-container>
